import angular from 'angular';

import component from './kitchen-manage.ng1.component';
import service from './kitchen-manage.service';

export default angular
    .module('control-room.menus.components.kitchen-manage', [])
    .component('crKitchenManage', component)
    .service('crKitchenManageService', ['crConfigurationService', service]);
